import { useCallback } from 'react';

const useAssetActions = ({
  queue,
  items,
  favorites,
  isPlaying,
  playlistId,
  activeIndex,
  visibleItemsIds,
  activePlaylistId,
  pauseTrackAction,
  replaceQueueAction,
  addToFavoritesAction,
  removeFromFavoritesAction,
}) => {
  const handlePlayClick = useCallback(
    (selectedIndex) => (event) => {
      event.stopPropagation();

      replaceQueueAction({
        queue: items,
        activeIndex: selectedIndex,
        activePlaylistId: playlistId,
        isPlaying: true,
      });
    },
    [items, playlistId, replaceQueueAction],
  );

  const handlePauseClick = useCallback((event) => {
        event.stopPropagation();
        pauseTrackAction();
    },
    [pauseTrackAction],
  );

  const isTrackPlaying = useCallback(
    (trackId, assetId, index) =>
      isPlaying &&
      activePlaylistId === playlistId &&
      visibleItemsIds.includes(index) &&
      trackId === queue[activeIndex]?.trackId &&
      assetId === queue[activeIndex]?.assetId,
    [queue, isPlaying, playlistId, visibleItemsIds, activePlaylistId, activeIndex],
  );

  const isInFavorites = useCallback((trackId) => favorites && favorites.indexOf(trackId) !== -1, [favorites]);

  const addToFavorites = useCallback(
    (trackId) => {
      addToFavoritesAction(trackId);
    },
    [addToFavoritesAction],
  );

  const removeFromFavorites = useCallback(
    (trackId) => {
      removeFromFavoritesAction(trackId);
    },
    [removeFromFavoritesAction],
  );

  return { handlePlayClick, handlePauseClick, isTrackPlaying, isInFavorites, addToFavorites, removeFromFavorites };
};

export default useAssetActions;
